<template>
	<div class="col-12">
	<div class="input-group">
		<input
		:value = "strSearch"
		@input = "handleSearch"
		type="text" class="form-control" placeholder="Search for..." />
		<span class="input-group-append">
			<button
			@click = "handleClear"
			class="btn btn-info" type="button">Clear!</button>
		</span>
	</div>
</div>

</template>
<script type="text/javascript">
	export default {
		name: "component-control-search",

		props: {
			strSearch: {type: String, default: ""}
		},
		data: function(){
			return {

			}
		},
		methods: {
			handleSearch: function(e){
				
				this.$emit("handleSearchControl", e.target.value);
			},

			handleClear: function(){
				this.$emit("handleClearControl");	
			}
		}
	}
</script>
<style type="text/css"></style>